<template>
  <div class="tags-box">
    <el-dialog :title="'图集详情'" :visible.sync="dialogVisible" width="680px" :before-close="handleClose" :close-on-click-modal="false">
      <div class="picturePopup">
        <img-load
          v-for="url in fileList"
          :key="url"
          style="width: 150px; height: 150px"
          :src="url" 
          :preview-src-list="fileList">
        </img-load>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      imgUrl: baseConfig.imgUrl,
      fileList: [], // 用于图片回显
    }
  },
  methods: {
    // 打开弹窗
    open(pictureArr) {
      this.fileList = pictureArr.map((item) => {
        return this.imgUrl + item;
      });
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fileList = [];
      this.pics = undefined;
    },
  }
}
</script>
<style scoped lang="scss">
.tags-box {
  .picturePopup {
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-height: 580px;
  }
}
</style>
